import * as XLSX from "xlsx";

interface RowData {
  [key: string]: any;
}

export default async function parseXlsx(file: File): Promise<RowData[]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target?.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const headers = rows[0] as [];
      const rowData: RowData[] = [];

      for (let i = 1; i < rows.length; i++) {
        const row = rows[i] as [];
        const rowDataItem: RowData = {};

        for (let j = 0; j < headers.length; j++) {
          const header = headers[j];
          rowDataItem[header] = row[j];
        }

        rowData.push(rowDataItem);
      }

      resolve(rowData);
    };
    reader.onerror = (e) => {
      reject(e);
    };
    reader.readAsBinaryString(file);
  });
}
